import { API_TYPE } from '@umu/umu-fetch';
const BasePath = '/napi/v1/quiz';

export const NodejsExamAPI = {
    /**
     *  获取考试题目
     */
    GET_QUIZ_QUESTION_LIST: {
        url: `${BasePath}/question-list`,
        type: API_TYPE.GET,
    },

    /**
     * 获取题目正确答案
     */
    GET_QUIZ_RIGHT_ANSWER_LIST: {
        url: `${BasePath}/question-right-answer`,
        type: API_TYPE.GET,
    },

    /**
     * 获取学员提交的答案
     */
    GET_QUIZ_USER_ANSWER_LIST: {
        url: `${BasePath}/user-answer`,
        type: API_TYPE.GET,
    },

    /**
     * 获取学员回答对错
     */
    GET_USER_QUIZ_RIGHT_RESULT: {
        url: `/megrez/exam/v1/user-question-right-result`,
        type: API_TYPE.GET,
    },

    /**
     * 获取学员考试统计结果
     */
    GET_QUIZ_SUMMARY: {
        url: `${BasePath}/summary`,
        type: API_TYPE.GET,
    },

    /**
     * 添加题目到考题本
     */
    ADD_QUESTION_COLLECTION: {
        url: `${BasePath}/question-collection/add`,
        type: API_TYPE.POST,
    },
};
